var map = {
	"./meta.json": "ae8c",
	"./views/contacts.json": "ff82",
	"./views/e-appeal.json": "37e2",
	"./views/home.json": "8a2b",
	"./views/news.json": "26ba",
	"./views/projects.json": "0e36"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4196";